@if (failure(); as authFailure) {
  <div
    class="auth-recovery-panel tw:fixed tw:top-0 tw:left-0 tw:w-full tw:h-full tw:bg-surface-0 tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-[1rem] tw:px-[1.5rem] tw:text-center"
  >
    <i
      class="tw:flex tw:h-[2rem] tw:w-[2rem] tw:text-p-orange-500"
      inlineSVG="sprites.svg#icon-warning"
    ></i>
    <div class="tw:text-[1.125rem] tw:font-semibold">{{ authFailure.title }}</div>
    <div class="tw:text-bluegray-600 tw:max-w-[30rem]">
      {{ authFailure.message }}
    </div>
    <prime-button
      severity="primary"
      label="Try again"
      (onClick)="retry()"
    />
  </div>
}
